<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Drivers</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Drivers
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="users-view">
                <!-- users view media object start -->
                <div class="row">
                    <div class="col-12 col-sm-7">
                        <div class="media mb-2">
                            <a class="mr-1" href="#">
                                <img :src="driverData.profile_photo_url ?? 'https://ui-avatars.com/api/?name=' + driverData.first_name + '+' + driverData.last_name"
                                     alt="users view avatar" class="users-avatar-shadow rounded-circle" height="64"
                                     width="64">
                            </a>
                            <div class="media-body pt-25">
                                <h4 class="media-heading">
                                    <span class="users-view-name">
                                        {{ driverData.first_name + " " + driverData.last_name }}
                                    </span>
                                </h4>
                                <span>ID:</span>
                                <span class="users-view-id">{{ driverData.id }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-5 px-0 d-flex justify-content-end align-items-center px-1 mb-2">
                        <button v-if="canEdit" type="button" class="btn btn-sm btn-primary" @click.prevent="openContactModal">
                            <i class="feather icon-edit icon-left"></i> Edit Contact
                        </button>
                    </div>
                </div>
                <!-- users view media object ends -->

<!--                <section class="card">-->
<!--                    <div class="card-body">-->
<!--                        <div class="row">-->
<!--                            <div class="col-md-3">-->
<!--                                <div class="left-bordered-card">-->
<!--                                    <strong>Completion rate:</strong> <br><br>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-3">-->
<!--                                <div class="left-bordered-card">-->
<!--                                    <strong>Earnings:</strong> <br><br>-->

<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-3">-->
<!--                                <div class="left-bordered-card">-->
<!--                                    <strong>No of Rides :</strong> <br><br>-->

<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-3">-->
<!--                                <div class="left-bordered-card">-->
<!--                                    <strong>Trip acceptance rate:</strong> <br><br>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                            <div class="col-md-3">-->
<!--                                <div class="left-bordered-card">-->
<!--                                    <strong>Cancellation rate:</strong> <br><br>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
<!--                </section>-->

                <section class="card">
                    <div class="card-body pt-3">
                        <div class="row">
                            <div class="col-md-4 mb-1">
                                <div class="stat-card">
                                    <i class="fa fa-check-circle stat-icon text-success"></i>
                                    <div class="stat-label">Completion rate (%)</div>
                                    <div class="stat-value">{{ driverData.completion_rate }}</div>
                                </div>
                            </div>

                            <div class="col-md-4 mb-1">
                                <div class="stat-card">
                                    <i class="fa fa-thumbs-up stat-icon text-primary"></i>
                                    <div class="stat-label">Trip acceptance rate (%)</div>
                                    <div class="stat-value">{{ driverData.trip_acceptance_rate }}</div>
                                </div>
                            </div>

                            <div class="col-md-4 mb-1">
                                <div class="stat-card">
                                    <i class="fa fa-ban stat-icon text-danger"></i>
                                    <div class="stat-label">Cancellation rate (%)</div>
                                    <div class="stat-value">{{ driverData.cancellation_rate }}</div>
                                </div>
                            </div>

                            <div class="col-md-4 mb-1">
                                <div class="stat-card">
                                    <i class="fa fa-wallet stat-icon text-info"></i>
                                    <div class="stat-label">Earnings (₦)</div>
                                    <div class="stat-value">{{ driverData.earnings }}</div>
                                </div>
                            </div>

                            <div class="col-md-4 mb-1">
                                <div class="stat-card">
                                    <i class="fa fa-car stat-icon"></i>
                                    <div class="stat-label">No of Rides</div>
                                    <div class="stat-value">{{ driverData.no_of_rides }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- users view card data start -->
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <h5 class="mb-1"><i class="feather icon-info"></i> Personal Info</h5>
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <table class="table table-borderless">
                                        <tbody>
                                            <tr>
                                                <td>Full Name:</td>
                                                <td class="users-view-username">
                                                    {{ driverData.first_name + ' ' + driverData.last_name}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Email:</td>
                                                <td class="users-view-name">{{ driverData.email }}</td>
                                            </tr>
                                            <tr>
                                                <td>Phone</td>
                                                <td class="users-view-email">{{ driverData.phone_number }}</td>
                                            </tr>
                                            <tr>
                                                <td>Registered at:</td>
                                                <td>{{ formatDateTime(driverData.created_at) }}</td>
                                            </tr>
                                            <tr>
                                                <td>Verified:</td>
                                                <td class="users-view-verified">{{ driverData.is_verified ? "Yes" : "No" }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12 col-md-6">
                                    <table class="table table-borderless">
                                        <tbody>
                                        <tr>
                                            <td>User Type:</td>
                                            <td class="users-view-role">Driver</td>
                                        </tr>
                                        <tr>
                                            <td>Total Rides:</td>
                                            <td class="users-view-role">{{ driverData.trips_count }}</td>
                                        </tr>
                                        <tr>
                                            <td>Wallet Balance:</td>
                                            <td class="users-view-role">{{ driverData.wallet?.balance ?? 0.00 }}</td>
                                        </tr>
                                        <tr>
                                            <td>Rating:</td>
                                            <td class="users-view-role">
                                                {{ starRating(driverData.ratings_avg_rating ?? 0) + ` (${driverData.ratings_count})` }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Status:</td>
                                            <td>
                                                <span :class="'users-view-status badge ' + statusClass(driverData.is_active)">{{ driverData.is_active ? "Active" : "Inactive" }}</span>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-12 mt-2 p-2">
                                    <div class="table-responsive">
                                        <table class="table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>Document Submitted</th>
                                                    <th>Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="document in driverData.modified_documents" class="mb-2 p-3 border rounded">
                                                    <th>{{ document.name }}</th>
                                                    <th>{{ document.status }}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- users view card data ends -->

                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Vehicles</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Vehicle Id</th>
                                            <th>Vehicle Type</th>
                                            <th>Vehicle Make</th>
                                            <th>Vehicle Model</th>
                                            <th>License plate</th>
                                            <th>Current Active Vehicle</th>
                                            <th>Ownership Type</th>
                                            <th>Owner</th>
                                            <th>Vehicle Status</th>
                                            <th></th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="vehicle in driverData.vehicles" class="mb-2 p-3">
                                            <th><a :href="route('admin.vehicles.show', vehicle.id)">{{ vehicle.id }}</a></th>
                                            <th>{{ vehicle.type.name }}</th>
                                            <th>{{ vehicle.vehicle_make }}</th>
                                            <th>{{ vehicle.vehicle_model }}</th>
                                            <th>{{ vehicle.license_plate }}</th>
                                            <th class="text-center">
                                                    <span :class="vehicle.is_active ? 'badge badge-success' : 'badge badge-warning'">
                                                        {{ vehicle.is_active ? 'Yes' : 'No' }}
                                                    </span>
                                            </th>
                                            <th>{{ vehicle.ownership_type }}</th>
                                            <th>
                                                <a v-if="vehicle.ownership_type === 'fleet_managed'" :href="route('admin.fleet_managers.show', vehicle.fleet_manager.id)">
                                                    {{ vehicle.fleet_manager.first_name + ' ' + vehicle.fleet_manager.last_name }}
                                                </a>
                                                <a v-else :href="route('admin.drivers.show', vehicle.driver.id)">{{ vehicle.driver.first_name + ' ' + vehicle.driver.last_name }}
                                                </a>
                                            </th>
                                            <th class="text-center">
                                                    <span :class="'badge-glow badge badge-' + tripStatus(vehicle.status)">
                                                        {{ vehicle.status }}
                                                    </span>
                                            </th>
                                            <th>
                                                <a :href="route('admin.vehicles.show', vehicle.id)">
                                                    <i class="feather icon-eye"></i> View
                                                </a>
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Last 5 Trips</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Ride Id</th>
                                            <th>Pickup Address</th>
                                            <th>Drop Address</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="trip in driverData.trips" class="mb-2 p-3">
                                                <th><a :href="route('admin.trips.show', trip.id)">{{ trip.id }}</a></th>
                                                <th>{{ truncateText(trip.pickup_address) }}</th>
                                                <th>{{ truncateText(trip.drop_address) }}</th>
                                                <th>{{ formatDateTime(trip.start_time) }}</th>
                                                <th>
                                                    <span :class="'badge-glow badge badge-' + tripStatus(trip.status)">
                                                        {{ trip.status }}
                                                    </span>
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Last 5 Transactions</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Transaction Id</th>
                                            <th>Transaction Type</th>
                                            <th>Amount</th>
                                            <th>Date</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="transaction in driverData.transactions" class="mb-2 p-3">
                                            <th>
                                                <a :href="route('admin.transactions.show', transaction.id)">
                                                    {{ transaction.id }}
                                                </a>
                                            </th>
                                            <th>
                                                <span :class="'badge ' + statusClass(transaction.type === 'credit')">
                                                    {{ transaction.type }}
                                                </span>
                                            </th>
                                            <th>{{ transaction.amount }}</th>
                                            <th>{{ formatDateTime(transaction.created_at) }}</th>
                                            <th>
                                                <span :class="'badge-glow badge badge-' + transactionStatus(transaction.readable_status)">
                                                    {{ transaction.readable_status }}
                                                </span>
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-content">
                        <div class="card-body">
                            <div class="col-12">
                                <h5 class="mb-3 font-weight-bold">Last 2 Reviews</h5>
                                <div class="table-responsive">
                                    <table class="table mb-0">
                                        <thead>
                                        <tr>
                                            <th>Review Id</th>
                                            <th>Trip Id</th>
                                            <th>Review</th>
                                            <th>Rating</th>
                                            <th>Date</th>
                                            <th>Reviewer</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="rating in driverData.ratings" class="mb-2 p-3">
                                            <th>{{ rating.id }}</th>
                                            <th>
                                                <a :href="route('admin.trips.show', `${rating.trip_id}`)">
                                                    {{ rating.trip_id }}
                                                </a>
                                            </th>
                                            <th>{{ rating.review}}</th>
                                            <th>{{ starRating(rating.rating) }}</th>
                                            <th>{{ formatDateTime(rating.created_at) }}</th>
                                            <th>
                                                <a :href="route('admin.users.show', `${rating.creatable_id}`)">
                                                    {{ `${rating.creatable?.first_name} ${rating.creatable?.last_name}` }}
                                                </a>
                                            </th>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- users view card details ends -->

            </section>
        </div>

        <div class="modal fade" id="edit-contact-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <form @submit.prevent="updateContact">
                        <div class="modal-header">
                            <h4 class="modal-title">Edit Contact Details</h4>
                            <button type="button" data-dismiss="modal" aria-label="Close" class="close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Email</label>
                                <input type="email" class="form-control" v-model="contactForm.email" required>
                                <div v-if="contactForm.errors.email" class="text-danger text-small">
                                    {{ contactForm.errors.email }}
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="form-group col-md-4">
                                    <label>Ext</label>
                                    <input type="text" class="form-control" v-model="contactForm.ext" required>
                                    <div v-if="contactForm.errors.ext" class="text-danger text-small">
                                        {{ contactForm.errors.ext }}
                                    </div>
                                </div>
                                <div class="form-group col-md-8">
                                    <label>Phone Number</label>
                                    <input type="text" class="form-control" v-model="contactForm.phone_number" required>
                                    <div v-if="contactForm.errors.phone_number" class="text-danger text-small">
                                        {{ contactForm.errors.phone_number }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                            <button type="submit" class="btn btn-primary" :disabled="saving">
                                Save <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'

export default {
    metaInfo: {title: 'Driver Admin'},
    name: 'DriverShow',
    props: ['driverData', 'canEdit'],
    layout: Layout,
    data() {
        return {
            contactForm: this.$inertia.form({
                email: null,
                phone_number: null,
                ext: null,
            }),
            saving: false,
        }
    },
    methods: {
        openContactModal() {
            this.contactForm.email = this.driverData.email
            this.contactForm.phone_number = this.driverData.phone_number
            this.contactForm.ext = this.driverData.ext
            this.contactForm.clearErrors()
            $('#edit-contact-modal').modal('show')
        },
        updateContact() {
            this.saving = true
            this.contactForm.put(route('admin.drivers.update', this.driverData.id), {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false
                    $('#edit-contact-modal').modal('hide')
                },
                onError: () => {
                    this.saving = false
                },
            })
        },
        // formatDate(value) {
        //     const date = new Date(value);
        //     const year = date.getFullYear();
        //     const month = String(date.getMonth() + 1).padStart(2, '0');
        //     const day = String(date.getDate()).padStart(2, '0');
        //     const hours = String(date.getHours()).padStart(2, '0');
        //     const minutes = String(date.getMinutes()).padStart(2, '0');
        //
        //     return `${year}-${month}-${day}`;
        // },
        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        statusClass(value) {
            return value ? "badge-success" : "badge-warning";
        },
        tripStatus(value) {
            if (value === 'pending' || value === 'verifying') {
                return "warning";
            } else if (value === 'accepted' || value === 'in_progress' || value === 'picked_up' || value === 'in_transit' || value === 'available')
            {
                return "success";
            } else if (value === 'completed' || value === 'active')
            {
                return "primary";
            } else {
                return "danger";
            }
        },
        transactionStatus(value) {
            if (value === 'pending') {
                return "warning";
            } else if (value === 'success')
            {
                return "success";
            } else {
                return "danger";
            }
        },
        starRating(rating) {
            if (rating === 0) {
                return '⭐️'.repeat(5);
            }
            return '⭐️'.repeat(Math.round(rating));
        },
        truncateText(text, length = 30) {
            return text?.length > length ? text.slice(0, length) + '...' : text;
        }
    },
    mounted() {},
}
</script>



